<div class="gi">
    <button type="button" class="gi-collapse-toggle" (click)="isInfoExpanded = !isInfoExpanded">
        <i class="pi" [ngClass]="isInfoExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        <span>Customer Info</span>
        <span class="gi-collapse-name" *ngIf="!isInfoExpanded">
            — {{ displayFirstName }} {{ displayLastName !== '-' ? displayLastName : '' }} · {{ displayBusinessName }}
        </span>
    </button>

    <!-- Read-only info tiles (collapsible) -->
    <div class="gi-grid" *ngIf="isInfoExpanded">
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-id-card"></i> First Name</span>
            <span class="gi-tile-value">{{ displayFirstName }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-id-card"></i> Last Name</span>
            <span class="gi-tile-value">{{ displayLastName }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-briefcase"></i> Business Name</span>
            <span class="gi-tile-value">{{ displayBusinessName }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-sitemap"></i> Business Type</span>
            <span class="gi-tile-value">{{ displayIndustryName }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-phone"></i> Contact Number</span>
            <span class="gi-tile-value">{{ displayContactNumber }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-envelope"></i> Contact Email</span>
            <span class="gi-tile-value">{{ displayContactEmail }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-map-marker"></i> No. of Locations</span>
            <span class="gi-tile-value">{{ displayNoOfLocations }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-home"></i> Address</span>
            <span class="gi-tile-value">{{ displayAddress }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-building"></i> City</span>
            <span class="gi-tile-value">{{ displayCity }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-flag"></i> State</span>
            <span class="gi-tile-value">{{ displayState }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-hashtag"></i> Zip</span>
            <span class="gi-tile-value">{{ displayZip }}</span>
        </div>
        <div class="gi-tile">
            <span class="gi-tile-label"><i class="pi pi-calendar"></i> Created Date</span>
            <span class="gi-tile-value">{{ displayCreatedDate ? (displayCreatedDate | date : "M/d/yyyy") : '-' }}</span>
        </div>
    </div>

    <!-- Account Status / Currency — always visible, never collapsed -->
    <div class="gi-grid gi-grid--pinned">
        <div class="gi-tile gi-tile--edit" *ngIf="isChangeStatus">
            <span class="gi-tile-label"><i class="pi pi-shield"></i> Account Status</span>
            <div class="gi-tile-edit-row">
                <p-dropdown
                    [formControl]="statusValue"
                    class="gi-dropdown"
                    [options]="statusList"
                    optionLabel="viewValue"
                    optionValue="value"
                    [autoDisplayFirst]="false"
                ></p-dropdown>
                <button
                    type="button"
                    pButton
                    pRipple
                    pTooltip="Save"
                    tooltipPosition="top"
                    aria-label="Save account status"
                    (click)="saveStatus()"
                    icon="pi pi-check"
                    [loading]="isSavingStatus"
                    [disabled]="!isStatusDirty || isSavingStatus || (isStatusReasonRequired && !statusReason.trim())"
                ></button>
            </div>
            <textarea
                *ngIf="isStatusDirty && isStatusReasonRequired"
                pInputTextarea
                rows="3"
                class="gi-status-reason"
                placeholder="Reason to change status (e.g. Payment overdue)"
                aria-label="Reason for changing account status"
                [(ngModel)]="statusReason"
            ></textarea>
        </div>

        <div class="gi-tile gi-tile--edit" *ngIf="showCurrencyDropdown">
            <span class="gi-tile-label"><i class="pi pi-dollar"></i> Currency</span>
            <div class="gi-tile-edit-row">
                <p-dropdown
                    class="gi-dropdown"
                    [options]="currencyOptions"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="selectedCurrency"
                    (ngModelChange)="onCurrencyChange($event)"
                    [autoDisplayFirst]="false"
                ></p-dropdown>
                <button
                    type="button"
                    pButton
                    pRipple
                    pTooltip="Save"
                    tooltipPosition="top"
                    aria-label="Save currency"
                    (click)="saveCurrency()"
                    icon="pi pi-check"
                    [loading]="isSavingCurrency"
                    [disabled]="!isCurrencyDirty || isSavingCurrency"
                ></button>
            </div>
        </div>

        <div class="gi-tile gi-tile--edit" *ngIf="showTimezoneDropdown">
            <span class="gi-tile-label"><i class="pi pi-clock"></i> Timezone</span>
            <div class="gi-tile-edit-row">
                <p-dropdown
                    class="gi-dropdown"
                    [options]="timezoneGroups"
                    [group]="true"
                    optionLabel="label"
                    optionValue="value"
                    optionGroupLabel="label"
                    optionGroupChildren="items"
                    placeholder="US Central"
                    [(ngModel)]="selectedTimezone"
                    (ngModelChange)="onTimezoneChange($event)"
                    [autoDisplayFirst]="false"
                    [filter]="true"
                    filterBy="label"
                    filterPlaceholder="Search timezone or city"
                ></p-dropdown>
                <button
                    type="button"
                    pButton
                    pRipple
                    pTooltip="Save"
                    tooltipPosition="top"
                    aria-label="Save timezone"
                    (click)="saveTimezone()"
                    icon="pi pi-check"
                    [loading]="isSavingTimezone"
                    [disabled]="!isTimezoneDirty || isSavingTimezone"
                ></button>
            </div>
            <!-- TODO re-enable: current-time display hidden, computed value doesn't match the selected zone's real local time -->
            <span class="gi-timezone-clock" *ngIf="false && selectedTimezoneCurrentTime">
                <i class="pi pi-clock"></i> Current time: {{ selectedTimezoneCurrentTime }}
            </span>
        </div>
    </div>

    <!-- Setup Progress — TODO re-enable: flip SETUP_PROGRESS_ENABLED to true -->
    <div class="gi-setup-progress" *ngIf="SETUP_PROGRESS_ENABLED">
        <span class="gi-setup-title">Setup Progress</span>
        <div class="gi-progress-items">
            <div class="gi-progress-item" [class.gi-progress-item--done]="productCreated">
                <i class="pi" [ngClass]="productCreated ? 'pi-check-circle' : 'pi-circle'"></i>
                <span>Product Created</span>
            </div>
            <div class="gi-progress-item" [class.gi-progress-item--done]="storeSetupCompleted">
                <i class="pi" [ngClass]="storeSetupCompleted ? 'pi-check-circle' : 'pi-circle'"></i>
                <span>Store Setup</span>
            </div>
            <div class="gi-progress-item" [class.gi-progress-item--done]="stripeConnected">
                <i class="pi" [ngClass]="stripeConnected ? 'pi-check-circle' : 'pi-circle'"></i>
                <span>Stripe Connected</span>
            </div>
        </div>
    </div>

    <!-- Store Content (admin view of the "done-for-you" store-setup submission) -->
    <div class="pc-card" *ngIf="availSaveOffer">
        <div class="pc-card-head pc-card-head--clickable" (click)="isStoreContentExpanded = !isStoreContentExpanded">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-blue"><i class="pi pi-shopping-bag"></i></span>
                <div>
                    <span class="pc-card-title">Store Content</span>
                    <span class="pc-card-desc">Merchant opted in for the "we set up your store for free" offer.</span>
                </div>
            </div>
            <div class="pc-card-head-right" *ngIf="availSaveOffer">
                <p-tag
                    [value]="storeContentStatusRaw === 2 ? 'Completed' : (storeContentFileUrl ? 'Awaiting Admin' : 'Awaiting Merchant')"
                    [severity]="storeContentStatusRaw === 2 ? 'success' : (storeContentFileUrl ? 'warning' : 'info')"
                ></p-tag>
                <i class="pi pc-collapse-chevron" [ngClass]="isStoreContentExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
        </div>

        <ng-container *ngIf="availSaveOffer && isStoreContentExpanded">
            <!-- Completed -->
            <div class="pc-store-done" *ngIf="storeContentStatusRaw === 2">
                <i class="pi pi-check-circle"></i>
                <div>
                    <span class="pc-store-done-title">This offer has been completed by admin.</span>
                    <span class="pc-store-done-sub" *ngIf="storeContentCompletedDate">
                        Completed on {{ storeContentCompletedDate | date : "MMM d, y, h:mm a" }}
                    </span>
                </div>
            </div>

            <!-- Not completed: submitted file, or waiting on the merchant -->
            <ng-container *ngIf="storeContentStatusRaw !== 2">
                <div class="pc-store-file" *ngIf="storeContentFileUrl">
                    <i class="pi pi-paperclip"></i>
                    <a [href]="storeContentFileUrl" target="_blank" rel="noopener">View submitted store details</a>
                </div>
                <div class="pc-callout" *ngIf="!storeContentFileUrl">
                    <i class="pi pi-clock"></i>
                    <span>Waiting for the merchant to submit their store details.</span>
                </div>
            </ng-container>

            <div class="pc-store-field-row">
                <span class="pc-label" style="margin: 0">Status</span>

                <div class="gi-store-content-status-readonly" *ngIf="!isEditingStoreContentStatus">
                    <span class="gi-store-content-value">{{ storeContentStatusLabel }}</span>
                    <a class="gi-store-content-link" (click)="startEditingStoreContentStatus()">Edit</a>
                </div>

                <div class="gi-store-content-status-edit" *ngIf="isEditingStoreContentStatus">
                    <p-dropdown
                        [(ngModel)]="storeContentStatusDraft"
                        [options]="storeContentStatusOptions"
                        optionLabel="label"
                        optionValue="value"
                        [autoDisplayFirst]="false"
                        [disabled]="isSavingStoreContentStatus"
                        styleClass="gi-store-content-dropdown"
                    ></p-dropdown>
                    <button
                        type="button"
                        pButton
                        pRipple
                        pTooltip="Save"
                        tooltipPosition="top"
                        aria-label="Save store content status"
                        (click)="confirmStoreContentStatusChange()"
                        icon="pi pi-check"
                        [loading]="isSavingStoreContentStatus"
                        [disabled]="isSavingStoreContentStatus"
                    ></button>
                    <button
                        type="button"
                        pButton
                        pRipple
                        pTooltip="Cancel"
                        tooltipPosition="top"
                        aria-label="Cancel editing store content status"
                        (click)="cancelEditingStoreContentStatus()"
                        icon="pi pi-times"
                        class="p-button-text"
                        [disabled]="isSavingStoreContentStatus"
                    ></button>
                </div>
            </div>

            <div class="pc-store-field-row">
                <span class="pc-label" style="margin: 0">Show notification bar</span>
                <p-inputSwitch [ngModel]="storeContentShowNotificationBar" (ngModelChange)="onToggleStoreContentNotificationBar($event)"></p-inputSwitch>
            </div>
        </ng-container>
    </div>

    <!-- Online Store Setup (admin view of the merchant's WebStore template creation) -->
    <div class="pc-card" *ngIf="false && onlineStoreInitiated">
        <div class="pc-card-head">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-blue"><i class="pi pi-globe"></i></span>
                <div>
                    <span class="pc-card-title">Online Store Setup</span>
                    <span class="pc-card-desc">Merchant's storefront template creation status.</span>
                </div>
            </div>
            <div class="pc-card-head-right">
                <p-tag
                    [value]="isTemplateSetupCompleted ? 'Completed' : (onlineStoreCreated ? 'Awaiting Admin' : 'Awaiting Store Creation')"
                    [severity]="isTemplateSetupCompleted ? 'success' : (onlineStoreCreated ? 'warning' : 'info')"
                ></p-tag>
            </div>
        </div>

        <!-- Completed -->
        <div class="pc-store-done" *ngIf="isTemplateSetupCompleted">
            <i class="pi pi-check-circle"></i>
            <div>
                <span class="pc-store-done-title">Template setup has been completed.</span>
                <span class="pc-store-done-sub" *ngIf="templateSetupCompletedDate">
                    Completed on {{ templateSetupCompletedDate | date : "MMM d, y, h:mm a" }}
                </span>
            </div>
        </div>

        <!-- Not completed -->
        <ng-container *ngIf="!isTemplateSetupCompleted">
            <div class="pc-store-file" *ngIf="onlineStoreUrl">
                <i class="pi pi-link"></i>
                <a [href]="onlineStoreUrl" target="_blank" rel="noopener">{{ onlineStoreUrl }}</a>
            </div>
            <div class="pc-callout" *ngIf="!onlineStoreCreated">
                <i class="pi pi-clock"></i>
                <span>Waiting for the merchant's store site to be created.</span>
            </div>

            <div class="pc-store-field-row" *ngIf="onlineStoreSubdomain">
                <span class="pc-label" style="margin: 0">Subdomain</span>
                <span class="gi-store-content-value">{{ onlineStoreSubdomain }}.lincsell.com</span>
            </div>

            <div class="gi-store-brand-colors" *ngIf="brandColors.length">
                <span class="pc-label" style="margin: 0">Brand colors</span>
                <div class="gi-store-brand-colors-list">
                    <span
                        class="gi-store-brand-chip"
                        *ngFor="let colorCode of brandColors"
                        [style.background-color]="getBrandColorInfo(colorCode).hex"
                        [style.color]="getBrandColorTextColor(colorCode)"
                    >{{ getBrandColorInfo(colorCode).name }}</span>
                </div>
            </div>

            <div class="gi-store-template-card" *ngIf="selectedTemplateInfo">
                <div class="gi-store-template-preview" [style.background-image]="'url(' + selectedTemplateInfo.image + ')'"></div>
                <div class="gi-store-template-footer">
                    <span>Template selected</span>
                    <strong>{{ selectedTemplateInfo.name }}</strong>
                </div>
            </div>

            <div class="pc-store-field-row" *ngIf="onlineStoreCreatedDate">
                <span class="pc-label" style="margin: 0">Created on</span>
                <span class="gi-store-content-value">{{ onlineStoreCreatedDate | date : "MMM d, y" }}</span>
            </div>

            <div class="pc-store-field-row" *ngIf="!selectedTemplateInfo">
                <span class="pc-label" style="margin: 0">Template Id</span>
                <span class="gi-store-content-value">{{ onlineStoreTemplateId }}</span>
            </div>

            <div class="pc-store-field-row" *ngIf="templateSetupStartedDate">
                <span class="pc-label" style="margin: 0">Setup Started</span>
                <span class="gi-store-content-value">{{ templateSetupStartedDate | date : "MMM d, y, h:mm a" }}</span>
            </div>

            <div class="pc-store-field-row">
                <span class="pc-label" style="margin: 0">Custom Store Requested</span>
                <span class="gi-store-content-value">
                    {{ customOnlineStoreRequested ? 'Yes' : 'No' }}
                    <ng-container *ngIf="customOnlineStoreRequested && customOnlineStoreRequestedDate">
                        ({{ customOnlineStoreRequestedDate | date : "MMM d, y, h:mm a" }})
                    </ng-container>
                </span>
            </div>

            <div class="pc-store-field-row">
                <span class="pc-label" style="margin: 0">Status</span>

                <div class="gi-store-content-status-readonly" *ngIf="!isEditingOnlineStoreSetupStatus">
                    <span class="gi-store-content-value">{{ onlineStoreSetupStatusLabel }}</span>
                    <a class="gi-store-content-link" (click)="startEditingOnlineStoreSetupStatus()">Edit</a>
                </div>

                <div class="gi-store-content-status-edit" *ngIf="isEditingOnlineStoreSetupStatus">
                    <p-dropdown
                        [(ngModel)]="onlineStoreSetupStatusDraft"
                        [options]="onlineStoreSetupStatusOptions"
                        optionLabel="label"
                        optionValue="value"
                        [autoDisplayFirst]="false"
                        [disabled]="isSavingOnlineStoreSetupStatus"
                        styleClass="gi-store-content-dropdown"
                    ></p-dropdown>
                    <button
                        type="button"
                        pButton
                        pRipple
                        pTooltip="Save"
                        tooltipPosition="top"
                        aria-label="Save online store setup status"
                        (click)="confirmOnlineStoreSetupStatusChange()"
                        icon="pi pi-check"
                        [loading]="isSavingOnlineStoreSetupStatus"
                        [disabled]="isSavingOnlineStoreSetupStatus"
                    ></button>
                    <button
                        type="button"
                        pButton
                        pRipple
                        pTooltip="Cancel"
                        tooltipPosition="top"
                        aria-label="Cancel editing online store setup status"
                        (click)="cancelEditingOnlineStoreSetupStatus()"
                        icon="pi pi-times"
                        class="p-button-text"
                        [disabled]="isSavingOnlineStoreSetupStatus"
                    ></button>
                </div>
            </div>
        </ng-container>
    </div>
</div>
